import { ErrorHandler } from "../ErrorHandler";
import { SessionStore } from "../../uidispatcherapi/SessionStore";
import { Store } from "../../utils/Store";
import * as ServerRequestsInternal from "../../server/ServerRequestsInternal";
import type { BasicStoreConfig, CountryOpeningHours, StoreOpeningHours } from "../../model/StoreInformation";
import { getCountryStores } from "../../server/StoreInfoRequests";
export type CountryStoresState = {
	stores: Record<string, CountryStoreInfo> | null | undefined;
	isPending: boolean;
};
export type CountryStoreInfo = BasicStoreConfig & {
	openingHours: StoreOpeningHours | null | undefined;
	storeId: string;
};
export class CountryStoresStoreImpl extends Store {
	_state: CountryStoresState;
	_errorHandler: ErrorHandler = new ErrorHandler([]);

	constructor() {
		super();
		this._state = {
			stores: null,
			isPending: false,
		};
		this.listenTo(SessionStore, () => {
			this.initIfNecessary().catch((error) => {
				console.error("initIfNecessary in CountryStoresStore failed with ", error);
			});
		});
	}

	async initIfNecessary() {
		if (!this._state.stores && !this._state.isPending && SessionStore.loggedIn()) {
			this._state = { ...this._state, isPending: true };
			const stores = await this.load();
			this._state = {
				isPending: false,
				stores,
			};
			this.trigger();
		}
	}

	async getStoreOpeningHours(): Promise<CountryOpeningHours | null | undefined> {
		try {
			return await ServerRequestsInternal.fetchStoreOpeningHours({
				country: SessionStore.getCountry(),
				locale: SessionStore.getLocale(),
			});
		} catch (err) {
			this._errorHandler.onError(null, err as any);

			return null;
		}
	}

	async load() {
		try {
			const storeData = await getCountryStores({
				country: SessionStore.getCountry(),
			});

			if (!storeData) {
				return null;
			}

			const openingHours = await this.getStoreOpeningHours();
			return Object.entries(storeData).reduce(
				(acc, [key, value]) => ({
					...acc,
					[key]: {
						...value,
						storeId: key,
						openingHours:
							openingHours && openingHours.storeInformationMap && openingHours.storeInformationMap[key],
					},
				}),
				{},
			);
		} catch (err) {
			this._errorHandler.onError(null, err as any);

			return null;
		}
	}

	getState(): CountryStoresState {
		return this._state;
	}
}
export const CountryStoresStore = new CountryStoresStoreImpl();
